export default __webpack_public_path__ + "static/media/story.402e787c.jpg";